import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dongzuo', label: '动作片' },
    { to: '/category/kehuan', label: '科幻片' },
    { to: '/category/xiju', label: '喜剧片' },
    { to: '/category/donghua', label: '动画片' },
    { to: '/about', label: '关于我们' },
  ];

  const features = [
    { label: '不缓冲播放', icon: 'ri-speed-line' },
    { label: '高清画质', icon: 'ri-4k-line' },
    { label: '无广告干扰', icon: 'ri-advertisement-line' },
    { label: '海量资源', icon: 'ri-database-2-line' },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                  八
                </span>
                <span className="font-heading font-bold text-xl text-background-50">
                  八戒电影网
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed mb-4">
                八戒电影网采用高速服务器确保不缓冲流畅播放，高清影视资源无广告快速加载，告别卡顿等待享受极致观影体验。
              </p>
              <div className="flex flex-wrap gap-3">
                {features.map((f) => (
                  <span
                    key={f.label}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-800 text-foreground-300 text-xs whitespace-nowrap"
                  >
                    <i className={`${f.icon} text-sm`}></i>
                    {f.label}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                快速导航
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {quickLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-foreground-400 hover:text-primary-400 transition-colors text-sm py-1 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                联系我们
              </h4>
              <div className="space-y-3 text-sm text-foreground-400">
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>service@bajiemovie.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-customer-service-line text-primary-400"></i>
                  <span>在线客服：7×24小时</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-primary-400"></i>
                  <span>安全认证 · 正版保障</span>
                </div>
              </div>
              <div className="flex gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信公众号">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 八戒电影网 bajiemovie.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}